// extracted by mini-css-extract-plugin
export default {"presaleTable":"inventory_presaleTable__jgxJs"};